// extracted by mini-css-extract-plugin
export default {"wrap":"didVWSAowHHpiCuICqzB","moved":"CVdaKOX5vvsfX1juCyhC"};